import { EventEmitter } from 'events';

import { EVENTS } from '@/Common/Runtime/events';

import * as sagaHelpers from './store/sagas/helpers';
import * as restHelpers from './rest/helpers';

export { sagaHelpers, restHelpers };

import '@/HostApp/styles/global.scss';
import '@/HostApp/styles/vars.scss';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createEmitter = (options?: any): EventEmitter => new EventEmitter(options);

export const getEventsMethods = (emitter: EventEmitter): App.IEmitterHostMethods => ({
	/**
	 * Add listener on event from host
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	onFromHost(listener: (...args: any[]) => void): void {
		emitter.addListener(EVENTS.PUBLIC.FROM_HOST, listener);
	},

	/**
	 * Remove listener on event from host
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	offFromHost(listener: (...args: any[]) => void): void {
		emitter.removeListener(EVENTS.PUBLIC.FROM_HOST, listener);
	}
});

export const getAnalyticsMethods = (emitter: EventEmitter): App.IAnalyticsMethods => ({
	/**
	 * Emit event to Google Analytics
	 */
	sendAnalytics(payload?: App.IPayloadData<Analytics.ITypedData>): void {
		emitter.emit(EVENTS.PRIVATE.TO_HOST, payload);
	}
});
